import React from 'react';
import { Typography } from '@mui/material';

const Section = (props) => (
  <Typography
    fontWeight='700'
    variant='h6'
    mb={2}
    textTransform='uppercase'
    {...props}
  />
);

export default Section;
